import actions from './actions'
import getters from './getters'
import { mutations } from './mutations'
import { getDefaultState } from './state'

export default {
  namespaced: true,
  state: getDefaultState(),
  actions,
  getters,
  mutations
}
